package empiresmp.feature.gallery.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class GalleryItem(
    @SerialName("id")
    val id: Long,
    @SerialName("title")
    val title: String,
    @SerialName("description")
    val description: String? = null,
    @SerialName("season")
    val season: String,
    @SerialName("server")
    val server: String,
    @SerialName("images")
    val images: List<GalleryImage>
)
